import React from "react";

// CUSTOM
import {
  POIInfo,
  StazeInfo,
  RandomClickInfo
} from "@/ui/PublicPage/SidebarPanes";
import { IInfoPane } from "@/@types/views/GIS/map";

type PublicInfoPaneProps = {
  infoPane?: IInfoPane;
  mobile?: boolean;
  handleAdd: (coord: number[] | undefined, label: string) => void;
  handleShowCommentPane: (newCommentPane: object) => void;
  handleOpenObilaznica?: (id: number, poi_id: number) => void;
  handleOpenLDTPane: (ldtId: number, ldtStageId: number) => void;
};

function PublicInfoPane(props: PublicInfoPaneProps) {
  const { infoPane, mobile, handleShowCommentPane, handleAdd, handleOpenObilaznica, handleOpenLDTPane } = props;

  const type = infoPane?.type;
  const subtype = infoPane?.subtype;

  const pickInfoPaneType = () => {
    if (type === "poi") {
      return (
        <POIInfo
          handleAdd={handleAdd}
          handleShowCommentPane={handleShowCommentPane}
          infoPane={infoPane}
          onOpenObilaznica={handleOpenObilaznica}
        />
      );
    }
    
    if (type === "staze") {
      return (
        <StazeInfo
          handleShowCommentPane={handleShowCommentPane}
          planStaza={subtype === "plan" ? true : false}
          infoPane={infoPane}
          handleOpenLDTPane={handleOpenLDTPane}
        />
      );
    }
    
    if (type === "random") {
      return (
        <RandomClickInfo
          handleAdd={handleAdd}
          handleShowCommentPane={handleShowCommentPane}
          infoPane={infoPane}
          handleOpenLDTPane={handleOpenLDTPane}
        />
      );
    }
    
    return null;
  };
  return (
    <>
      {pickInfoPaneType()}
    </>
  );
}

export default PublicInfoPane;
